var _a;
import { __decorate, __metadata, __param } from "tslib";
// @ts-nocheck
import { getSyncFieldValueApi, setSyncFieldValueApi } from '@cores/apis/workspace_api/folder';
import { Toast } from 'patsnap-biz';
import _ from 'lodash';
import { rvTrack } from 'track';
import { inject, provide } from '@/inversify.config';
import { UserCapacityService } from '@/domains/user/services/user-capacity-service.interface';
export const SyncFamilyFieldValueServiceSymbol = Symbol('SyncFamilyFieldValueService');
let SyncFamilyFieldValueService = class SyncFamilyFieldValueService {
    constructor(userCapacityService) {
        this.userCapacityService = userCapacityService;
        this.syncFieldValue = false;
        this.familyExpandBuzType = [];
        this.oldFolderId = '';
        this.params = {
            sync_field_value: false,
            family_expand_buz_type: [],
        };
        this.loading = false;
        this.folderId = null;
        this.familyExpandBuzTypeList = [
            'ADD_PATENT_MANUAL',
            'ADD_PATENT_AUTO',
            'BULK_EDIT',
        ];
    }
    get limit() {
        return this.userCapacityService.getUserCapacityByKey('max_op');
    }
    init({ folder_id, }) {
        this.oldFolderId = folder_id;
        if (this.oldFolderId === this.folderId)
            return;
        this.loading = true;
        this.folderId = folder_id;
        getSyncFieldValueApi({ folder_id })
            .then(res => {
            this.syncFieldValue = _.get(res, 'sync_field_value') || false;
            this.familyExpandBuzType = _.get(res, 'family_expand_buz_type') || [];
            if (!this.syncFieldValue) {
                this.familyExpandBuzType = [];
            }
            this.resetParams();
            this.loading = false;
        })
            .catch(err => {
            this.loading = false;
            Toast({
                type: 'error',
                message: err._error_msg,
                showClose: true,
            });
        });
    }
    updateSyncFieldValueStatus({ collapseField, }) {
        const { sync_field_value, family_expand_buz_type } = _.cloneDeep(this.params);
        const { folderId: folder_id } = this;
        if (sync_field_value === this.syncFieldValue && _.isEqual(family_expand_buz_type, this.familyExpandBuzType)) {
            return false;
        }
        this.loading = true;
        setSyncFieldValueApi({
            folder_id,
            sync_field_value,
            family_expand_buz_type,
        })
            .then(() => {
            this.loading = false;
            this.syncFieldValue = sync_field_value;
            this.familyExpandBuzType = family_expand_buz_type;
            this.resetParams();
            rvTrack('Edit Custom Field Across Family OR APN', {
                collapse_field: collapseField,
                folder_id,
                sync_field_value,
                family_expand_buz_type,
            });
        })
            .catch(error => {
            this.resetParams();
            Toast({
                type: 'error',
                message: error._error_msg,
                showClose: true,
            });
        });
    }
    resetParams() {
        this.params = {
            sync_field_value: this.syncFieldValue,
            family_expand_buz_type: [...this.familyExpandBuzType],
        };
    }
};
SyncFamilyFieldValueService = __decorate([
    provide(SyncFamilyFieldValueServiceSymbol),
    __param(0, inject(UserCapacityService)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserCapacityService !== "undefined" && UserCapacityService) === "function" ? _a : Object])
], SyncFamilyFieldValueService);
export { SyncFamilyFieldValueService };
